import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Container, Grid2, IconButton, Tooltip } from '@mui/material'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import Loading from '../../../BuiltInComponent/Loading'
import { getPDData, getPDMasterData } from '../../../features/StockManagement/Purchases/pdSlice'
import { printPurchaseDocument } from '../../../utils/purchaseDocumentPrint'
import { exportPurchaseDocumentExcel, exportPurchaseDocumentPDF } from '../../../utils/purchaseDocumentExport'
import AssessmentIcon from '@mui/icons-material/Assessment'

export default function PurchaseRequestList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { masterData, isLoading } = useSelector((state) => state.pd)
    const { user } = useSelector((state) => state.auth)

    React.useEffect(() => {
        dispatch(getPDMasterData())
        // dispatch(getPurchaseDetailData('blank'))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'pdID', cName: 'Invoice No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'pdID', cName: 'P.R. ID', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'entDate', cName: 'Post Date', textAlign: 'left', width: 80, status: 'en', dType: 'date' },
        { fieldName: 'dispName', cName: 'Request By', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'PartyName', cName: 'Vendor / Supplier', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'supplierGrnRefNo', cName: 'Supplier GRN Ref No', textAlign: 'left', width: 130, status: 'en', dType: 'string' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'grnSourceLabel', cName: 'GRN Source', textAlign: 'left', width: 100, status: 'en', dType: 'string' },
        { fieldName: 'pdStatus', cName: 'Current Status', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'totalItems', cName: 'Total Items', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string', action: true },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string', action: true },
        { fieldName: 'Print', cName: 'Print', textAlign: 'center', width: 80, status: 'en', dType: 'string', icon: 'print', action: true },
        { fieldName: 'Excel', cName: 'Excel', textAlign: 'center', width: 80, status: 'en', icon: 'excel', action: true },
        { fieldName: 'PDF', cName: 'PDF', textAlign: 'center', width: 70, status: 'en', icon: 'pdf', action: true },
    ];

    const onEditClick = async (itemCode) => {
        navigate('/AddGRN', { state: { pdID: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }

    const onPrintClick = async (pdID) => {
        const printWindow = window.open('', '_blank', 'width=1000,height=800')
        if (!printWindow) return alert('Please allow pop-ups to print the GRN.')
        printWindow.document.write('<p style="font-family:Arial;padding:24px">Preparing GRN...</p>')
        try {
            const data = await dispatch(getPDData(pdID)).unwrap()
            const listRow = (masterData || []).find(row => Number(row.pdID) === Number(pdID))
            printPurchaseDocument(printWindow, 'GRN', data?.pm?.[0], data?.pd || [], listRow, user)
        } catch (error) {
            printWindow.close()
            alert(`GRN print failed: ${error}`)
        }
    }

    const exportDocument = async (pdID, exporter) => {
        try {
            const data = await dispatch(getPDData(pdID)).unwrap()
            const listRow = (masterData || []).find(row => Number(row.pdID) === Number(pdID))
            exporter({ type: 'GRN', master: data?.pm?.[0], details: data?.pd || [], listRow })
        } catch (error) {
            alert(`GRN export failed: ${error}`)
        }
    }
    const onAddNewClick = () => {

        navigate('/AddGRN')

    }

    return (
        <>
            <Navbar />
            <Container maxWidth={false} sx={{ px: { xs: 1, md: 3 } }}>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={7}>

                    </Grid2>
                    <Grid2 size={4}>
                        <ButtonNormal text='Add New Purchase Delvery (GRN)' onClick={onAddNewClick} />
                    </Grid2>
                    <Grid2 size={1} sx={{ textAlign: 'right' }}>
                        <Tooltip title='Current Stock Report'>
                            <IconButton color='primary' size='large' sx={{ p: 1.25 }} onClick={() => navigate('/CurrentStock')}>
                                <AssessmentIcon fontSize='large' />
                            </IconButton>
                        </Tooltip>
                    </Grid2>
                </Grid2>
                {isLoading ? <Loading /> :
                    <StickyHeadTable tableColumns={tableColumns} tableData={masterData && masterData}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} onButtonClick={onPrintClick} onPrintClick={onPrintClick}
                        onExcelClick={(pdID) => exportDocument(pdID, exportPurchaseDocumentExcel)} onPdfClick={(pdID) => exportDocument(pdID, exportPurchaseDocumentPDF)} />
                }

            </Container>
        </>
    )
}
